import {Action} from "../../../action/action";
import type DetailsState from "..";

export const ACCEPT_CONDITIONS = "ACCEPT_CONDITIONS";

export class AcceptConditions extends Action<typeof ACCEPT_CONDITIONS, true> {
  readonly type = ACCEPT_CONDITIONS;
  protected state: DetailsState;

  constructor(state: DetailsState, acceptConditions?: true | undefined) {
    super(state, acceptConditions);
    this.state = state;
  }
  /**
   * Business logic:
   * This should always be set, as a customer shouldnt be allowed to buy anything from us,
   * without them agreeing to the terms of our business.
   * EXCEPT: For CompanyLeads, as they're not buying anything, yet.
   * @returns
   */
  public isDoable(): boolean {
    return true;
  }
  public isValid(): boolean {
    return this.isDoable();
  }
}
